import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

import {parseFuelTankRatio} from './parseFuelTankRatio';

const EIGHTHS_PER_TANK = 8;

const FUEL_TANK_EIGHTH_LABELS = [
  'E',
  '1/8',
  '1/4',
  '3/8',
  '1/2',
  '5/8',
  '3/4',
  '7/8',
  'F',
] as const;

/**
 * @about Formats the rental fuel tank level, stored as a 0–1 ratio in a decimal string,
 * as the nearest eighth-tank label. A missing, blank, unparseable or out-of-range value
 * is formatted as null so the caller renders its placeholder instead of a wrong level.
 */
export function formatFuelTank(value: string | Nullish): string | null {
  const ratio = parseFuelTankRatio(value);

  if (isNil(ratio)) {
    return null;
  }

  return FUEL_TANK_EIGHTH_LABELS[Math.round(ratio * EIGHTHS_PER_TANK)];
}
